// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1605":"aca49690","8274":"22bef1e0"}[chunkId] + ".chunk.css";
};